/* eslint-disable */
export default {
  _Futura: 'Futura',
  _Tertre_Med: 'Tertre Med',
  _gantonregular: 'gantonregular',
}